import { render, staticRenderFns } from "./DealerDetails.vue?vue&type=template&id=89ea3240"
import script from "./DealerDetails.vue?vue&type=script&lang=js"
export * from "./DealerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports